<script>
import * as constants from '@/utilities/appConsts'

export default {
  props: {
    value: {
      type: [Array, Number, String, null],
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    lockedItems: {
      type: Array,
      default: () => [],
    },
    componentType: {
      type: String,
      default: constants.AUTOCOMPLETE_TYPES.single,
      validator: val =>
        [
          constants.AUTOCOMPLETE_TYPES.single,
          constants.AUTOCOMPLETE_TYPES.multiple,
          constants.AUTOCOMPLETE_TYPES.extendedMultiple,
        ].includes(val),
    },
    floatFilter: {
      type: Boolean,
      default: false,
    },
    useStrings: {
      type: Boolean,
      default: false,
    },
    noArray: {
      type: Boolean,
      default: false,
    },
    noLabel: {
      type: Boolean,
      default: false,
    },
    noSearchInput: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: '',
    },
    labelBelow: {
      type: Boolean,
      default: false,
    },
    detailRowProp: {
      type: String,
      default: '',
    },
    dropDownSizeMatches: {
      type: Boolean,
      default: false,
    },
    displayClear: {
      type: Boolean,
      default: false,
    },
    noReset: {
      type: Boolean,
      default: false,
    },
    displayGroupName: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    isMultiple() {
      return (
        this.componentType === constants.AUTOCOMPLETE_TYPES.multiple ||
        this.componentType === constants.AUTOCOMPLETE_TYPES.extendedMultiple
      )
    },
    isExtendedMultiple() {
      return (
        this.componentType === constants.AUTOCOMPLETE_TYPES.extendedMultiple
      )
    },
  },
}
</script>
